import { PointsContainer } from '@/features/points/PointsContainer'

export function Points() {
  return <PointsContainer />
}
